<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

          <template v-slot:item.alta="{ item }">
            <span class="text-vermelho">
              {{ item.alta }}
            </span>
          </template>

          <template v-slot:item.intermediaria="{ item }">
            <span class="text-laranja">
              {{ item.intermediaria }}
            </span>
          </template>

          <template v-slot:item.baixa="{ item }">
            <span class="text-verde">
              {{ item.baixa }}
            </span>
          </template>

          <template v-slot:item.nao_aguda="{ item }">
            <span class="text-azul">
              {{ item.nao_aguda }}
            </span>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} registros</span
            >
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9"></td>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaDia',
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedEstabelecimento: {
      type: Object,
      default: null,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Dia',
          align: 'start',
          filterable: true,
          value: 'nu_dia',
        },
        {
          text: 'Alta',
          align: 'start',
          filterable: true,
          value: 'alta',
        },
        {
          text: 'Intermediária',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'intermediaria',
        },
        {
          text: 'Baixa',
          align: 'start',
          filterable: true,
          value: 'baixa',
        },
        {
          text: 'Não aguda',
          align: 'start',
          filterable: true,
          sortable: true,
          value: 'nao_aguda',
        },
        {
          text: 'Sem classificação',
          align: 'start',
          filterable: true,
          value: 'sem_classificacao',
        },
        {
          text: 'Total do dia',
          align: 'start',
          filterable: true,
          value: 'total_do_dia',
        },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      return `table-row-color-${item.color}`
    },
  },
}
</script>

<style scoped>
.text-vermelho {
  color: #e53935;
  font-weight: 600;
}

.text-laranja {
  color: #fb8c00;
  font-weight: 600;
}

.text-verde {
  color: #43a047;
  font-weight: 600;
}

.text-azul {
  color: #1e88e5;
  font-weight: 600;
}
</style>
